document.addEventListener('DOMContentLoaded', (evt) => {
    addClickEventHref();
    createFilterObserver();  
})

function createFilterObserver() {
    const filtersContainer = document.querySelector('.refinement-body');

    const observer = new MutationObserver((mutations) => {
        let [...arraySizeSelected] = document.querySelectorAll('.size-refinement.selected');
        const childMutation = mutations.find( mutation => mutation.type === 'childList' )
        if ( childMutation ) addClickEventHref();
        if (arraySizeSelected.length == 1) comparedSizes(arraySizeSelected[0].children[0].textContent.trim());
    })

    observer.observe(filtersContainer, { childList: true, subtree: true })
}

function addClickEventHref() {
    let newHrefSizeContainer = document.querySelectorAll('.size-refinement');
    newHrefSizeContainer.forEach((aItem) => {
        aItem.addEventListener('click', (evt) => {
            const checkoForLoading = setInterval(() => {
                const existLoading = document.querySelector('.veil');
                if(!existLoading) {
                    let [...arraySizeSelected] = document.querySelectorAll('.size-refinement.selected');
                    if (arraySizeSelected.length == 1) comparedSizes(aItem.children[0].textContent.trim());
                    clearInterval(checkoForLoading);
                }
            }, 150)
        });
    });
}

function comparedSizes(sizeFilter) {
    const products = document.querySelectorAll('.product-tile');

    products.forEach((product) => {
        const productSizes = product.dataset.notAvailable.split('-');
        let sizes = productSizes.filter( x => x != '');

        sizes.forEach((item) => {
            if(item == sizeFilter) product.parentElement.remove();
        }) 
    });
}

